export class DataType {
    public static get STRING(): string {
        return 'string';
    }

    public static get INTEGER(): string {
        return 'integer';
    }

    public static get DECIMAL(): string {
        return 'decimal';
    }

    public static get BOOLEAN(): string {
        return 'boolean';
    }

    public static get JSON(): string {
        return 'json';
    }
}
